import FDictionary from '../__select';
import core from "@/core";
import Form from './Form';

export default class FDictionaryFlight extends FDictionary {

  dictionary = 'flight';
  permissionAdd = [-1];

  constructor(props) {
    super(props);
    if (props.city) {
      this.city = props.city;
    }
    if (props.cityTo) {
      this.cityTo = props.cityTo;
    }
    this.refs.$subscribe(model => this.getOptions(model));
    this.__showAdd = typeof props.showAdd === 'undefined' ? true : props.showAdd;
  }

  get showAdd() {
    if (!core.permission.hasAny(...this.permissionAdd)) {
      return false;
    }
    return this.__showAdd;
  }

  set showAdd(value) {
    this.__showAdd = value;
  }
  get city() {
    return this.refs.data.city;
  }

  set city(value) {
    if (!value) {
      return;
    }
    this.refs.data.city = value;
    this.refs.set('cityFrom', value);
  }

  get cityTo() {
    return this.refs.data.cityTo;
  }

  set cityTo(value) {
    if (!value) {
      return;
    }
    this.refs.data.cityTo = value;
    this.refs.set('cityTo', value);
  }

  getOptions(model = this.refs.data) {
    if (!model.cityFrom || !model.cityTo) {
      return Promise.resolve(this.setOptions([]));
    }
    return super.getOptions(model);
  }
  addForm() {
    const item = new Form();
    item.init()
      .then();
    return item;
  }
}
